import truncate from 'truncate'
import { number, string } from 'prop-types'

import HashtagRenderer from '../../../utilities/hashtagRenderer.js'

import './post-text.scss'

function PostText({ maxLength, postText, hashtagColor }) {
  if (!postText) {
    return null
  }

  const truncatedText = maxLength ? truncate(postText, maxLength) : postText

  return <HashtagRenderer hashtagStyle={{ color: hashtagColor }} text={truncatedText} />
}

PostText.propTypes = {
  hashtagColor: string,
  maxLength: number,
  postText: string,
}

export default PostText
